import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, Home, BookOpen, BarChart3, User, Heart } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';

export const SideMenu = ({ open, onOpenChange }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: 'home',
      label: 'Inicio',
      path: '/',
      icon: Home,
    },
    {
      id: 'collection',
      label: 'Colección',
      path: '/collection',
      icon: BookOpen,
    },
    {
      id: 'ranking',
      label: 'Ranking',
      path: '/ranking',
      icon: BarChart3,
    },
    {
      id: 'profile',
      label: 'Perfil',
      path: '/profile',
      icon: User,
    },
    {
      id: 'donate',
      label: 'Donar',
      path: 'https://www.paypal.com/donate/?hosted_button_id=LU5K3LYRDAFV8',
      icon: Heart,
      isExternal: true,
    },
  ];

  const handleAction = (item) => {
    if (item.isExternal) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[280px] p-0 border-r-0 shadow-2xl">
        <SheetHeader className="p-8 text-left border-b border-secondary bg-gradient-to-br from-primary/5 to-transparent">
          <div className="flex items-center gap-3 mb-2">
            <img
              src="/logo.png"
              alt="Logo"
              className="w-10 h-10 rounded-xl shadow-lg"
            />
            <SheetTitle className="text-2xl font-black tracking-tight bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Tetris Bíblico
            </SheetTitle>
          </div>
          <p className="text-xs text-muted-foreground font-medium uppercase tracking-widest pl-1">
            Menú Principal
          </p>
        </SheetHeader>
        <nav className="p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              const isDonate = item.id === 'donate';

              return (
                <li key={item.id} className="px-2">
                  <button
                    onClick={() => handleAction(item)}
                    className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl transition-all duration-300 ${isActive
                      ? 'bg-primary text-primary-foreground shadow-lg shadow-primary/20 scale-[1.02]'
                      : isDonate
                        ? 'hover:bg-rose-50 text-rose-600 border-2 border-rose-100 mt-6 shadow-sm shadow-rose-100'
                        : 'hover:bg-secondary text-muted-foreground hover:text-foreground'
                      }`}
                  >
                    <div className={`p-2 rounded-xl ${isActive ? 'bg-white/20' : isDonate ? 'bg-rose-100' : 'bg-secondary'}`}>
                      <Icon className={`w-5 h-5 ${isDonate ? 'fill-current' : ''}`} />
                    </div>
                    <span className="font-bold tracking-tight">{item.label}</span>
                    {isActive && (
                      <div className="ml-auto w-1.5 h-1.5 rounded-full bg-primary-foreground/50"></div>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </SheetContent>
    </Sheet>
  );
};